import strFunc from "@/lib/lyg/string";
import CoolenWordStudyData from "@/pcomponents/common/content/coolen/study/func/word_study_data";

function ContPartTableArea(props: any) {
  let myProps = {
    Style: {},
    pre_data: {},
    study_sort: "",
    cont_part: "word",
    ...props
  };
  let Style = myProps.Style;
  let pre_data = myProps.pre_data;
  let cont_part = myProps.cont_part;

  let study_sort = myProps.study_sort;

  let group_stu_det_his_arr: any = [];
  if (pre_data.group_stu_det_his_arr) {
    group_stu_det_his_arr = pre_data.group_stu_det_his_arr;
  }
  let det_his_date_arr: any = [];
  for (let h_i = 0; h_i < group_stu_det_his_arr.length; h_i++) {
    let h_data = group_stu_det_his_arr[h_i];
    let h_date = h_data.a_start_date.substring(0, 10);
    if (strFunc.str_in_array(h_date, det_his_date_arr) == -1) {
      det_his_date_arr.push(h_date);
    }
  }
  let th_data_arr = [
    { value: "date", text: "DATE", is_test: false },
    { value: "time", text: "TIME", is_test: false },
  ];
  let study_sort_det_arr = CoolenWordStudyData.get_study_det_arr({
    study_sort: study_sort
  });
  for (let det_i = 0; det_i < study_sort_det_arr.length; det_i++) {
    let det_data = study_sort_det_arr[det_i];
    if (det_data.value == "select_word") {
      continue;
    }
    if (det_data.cont_part == cont_part) {
      let tmp_is_test = false;
      if (det_data.sort.indexOf("test") != -1) {
        tmp_is_test = true;
      }
      th_data_arr.push({ value: det_data.value, text: det_data.text, is_test: tmp_is_test });
    }
  }

  const get_result_td_tags = (inData: any) => {
    let opt_obj = {
      th_data: {},
      ...inData
    };
    let th_data = opt_obj.th_data;
    let td_tags = det_his_date_arr.map((d_date: any, d_i: number) => {
      if (d_i >= max_date_cnt) {
        return false;
      }
      let group_his_data = null;
      for (let g_i = 0; g_i < group_stu_det_his_arr.length; g_i++) {
        let tmp_group_his_data = group_stu_det_his_arr[g_i];
        if (tmp_group_his_data["a_start_date"].substring(0, 10) == d_date
          && tmp_group_his_data["a_cont_part"] == cont_part
          && tmp_group_his_data["a_cont_sort_det"] == th_data.value) {
          group_his_data = tmp_group_his_data;
        }
      }

      let his_data_str = "";
      if (th_data.value == "date") {
        his_data_str = d_date.substring(5);
        his_data_str = his_data_str.replace("-", "/");
      } else if (th_data.value == "time") {
        let tmp_total_his_time_sec = 0;
        for (let g_i = 0; g_i < group_stu_det_his_arr.length; g_i++) {
          let tmp_group_his_data = group_stu_det_his_arr[g_i];
          if (tmp_group_his_data["a_start_date"].substring(0, 10) == d_date
            && tmp_group_his_data["a_cont_part"] == cont_part) {
            tmp_total_his_time_sec += parseInt(strFunc.uncomma(tmp_group_his_data["a_elapse_time_sec"]));
          }
        }
        let tmp_time_json = strFunc.secondsToTimeJson(tmp_total_his_time_sec);
        let tmp_time_str = strFunc.timeJsonToString(tmp_time_json);
        his_data_str = tmp_time_str;
      } else {
        if (group_his_data != null) {
          let tmp_time_json = strFunc.secondsToTimeJson(group_his_data["a_elapse_time_sec"]);
          let tmp_time_str = strFunc.timeJsonToString(tmp_time_json);
          if (th_data.value == "majak") {
            th_data.is_test = false;
          }
          if (th_data.is_test) {
            let tmp_per: any = 0;
            let a_correct_cnt = parseInt(strFunc.uncomma(group_his_data.a_correct_cnt));
            let a_matter_cnt = parseInt(strFunc.uncomma(group_his_data.a_matter_cnt));
            if (a_correct_cnt != 0 && a_matter_cnt != 0) {
              tmp_per = (a_correct_cnt / a_matter_cnt) * 100;
              tmp_per = tmp_per.toFixed(0);
              his_data_str = tmp_per + " / " + tmp_time_str;
            }
          } else {
            his_data_str = tmp_time_str;
          }
        }
      }

      return (
        <td key={d_i}>
          <div className={Style.td_div}>
            {his_data_str}
          </div>
        </td>
      );
    });

    return td_tags;
  };

  let max_date_cnt = 3;
  let tr_tags: any = [];
  for (let row_i = 0; row_i < th_data_arr.length; row_i++) {
    let th_data = th_data_arr[row_i];

    tr_tags.push((
      <tr key={row_i}>
        <th>{th_data.text}</th>
        {get_result_td_tags({
          th_data: th_data
        })}
      </tr>
    ));
  }

  return (
    <div className={Style.group_det_section}>
      <div className={Style.group_det_cont_title}>{myProps.cont_part}</div>
      <table className={Style.group_det_table}>
        <tbody>
          {tr_tags.map((item: any, idx: number) => {
            return item;
          })}
        </tbody>
      </table>
    </div>
  );
};
export default ContPartTableArea;